import Vue from 'vue'
const actions = {
    clearCargoByDocId: ({state, commit, rootGetters, dispatch}, payload) => {
        dispatch('incomingCargo/patch', { cleared: true, ...payload.cargo}, {root: true}).then(() => {
            return Vue.prototype.$FB.collection('incoming-cargos').doc(payload.id).update({
                clearedBy: payload.user,
                clearedAt:new Date(),
                cleared: true
            });
        })
    }
}

export default actions

